import React from 'react';
import { Route } from 'react-router-dom';
import withLoadable from 'utils/withLoadable';

const TenantListPage = withLoadable(() => import('./list'));
const TenantRouter = () => <Route path="/tenant" children={TenantListPage} />;

export default TenantRouter;
